import * as React from "react";

const RFQView = React.lazy(() => import("./RFQViewContainer"));

export { RFQView };
